import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { notification } from "antd";

const notificationStyles = {
  success: {
    backgroundColor: '#f6ffed',
    borderLeft: '4px solid #52c41a',
    color: '#237804',
  },
  error: {
    backgroundColor: '#fff1f0',
    borderLeft: '4px solid #ff4d4f',
    color: '#a8071a',
  },
  info: {
    backgroundColor: '#e6f7ff',
    borderLeft: '4px solid #1890ff',
    color: '#0050b3',
  },
  warning: {
    backgroundColor: '#fffbe6',
    borderLeft: '4px solid #faad14',
    color: '#613400',
  },
  // fallback style if unknown type
  default: {
    backgroundColor: '#fafafa',
    borderLeft: '4px solid #d9d9d9',
    color: '#595959',
  },
};

const Notifications = () => {
  const notifications = useSelector((state) => state.Notifications.notifications);
  const shownNotificationIds = useRef(new Set());

useEffect(() => {
  notifications.forEach(({ id, message, type }) => {
    if (!shownNotificationIds.current.has(id)) {
      const style = notificationStyles[type] || notificationStyles.default;

      const titleMap = { success: 'Shranjeno' };
      let title = titleMap[type] ?? (type.charAt(0).toUpperCase() + type.slice(1));
      let description = message;

      // ✅ Split title and description if using "Title|Description"
      if (message.includes('|')) {
        const [msgTitle, msgDescription] = message.split('|');
        title = msgTitle.trim();
        description = msgDescription.trim();
      }

      const notify = typeof notification[type] === 'function' ? notification[type] : notification.info;

      notify({
        message: title,
        description,
        key: id,
        duration: 3,
        style,
        placement: 'bottomRight',
      });

      shownNotificationIds.current.add(id);
    }
  });
}, [notifications]);

  return null;
};

export default Notifications;
